import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

/**
 * SSR proof local storage usage
 */
@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor(@Inject(PLATFORM_ID) public platformId: object) {}

  getItem(key: string): string | null {
    if (isPlatformBrowser(this.platformId) && localStorage) {
      return localStorage.getItem(key);
    }
    return null;
  }

  setItem(key: string, val: string) {
    if (isPlatformBrowser(this.platformId) && localStorage) {
      localStorage.setItem(key, val);
    }
  }

  removeItem(key: string) {
    if (isPlatformBrowser(this.platformId) && localStorage) {
      localStorage.removeItem(key);
    }
  }

  /**
   * Iterates over all local storage entries and removes entries that start with prefix string passed in.
   *
   * @param prefix local storage entries with a key that starts with this string will be deleted.
   */
  removeLocalStorageItemsByPrefix(prefix: string) {
    if ((!isPlatformBrowser(this.platformId) && localStorage) || !prefix) {
      return;
    }
    for (let i: number = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(prefix)) {
        this.removeItem(key);
      }
    }
  }
}
